import { gql } from '@apollo/client'

export const personalDataMutation = gql`
  mutation updateUserData($firstName: String!, $lastName: String!, $birthDate: String!) {
    updateUserData(firstName: $firstName, lastName: $lastName, birthDate: $birthDate) {
      success
    }
  }
`
